/**
 * Exports Table Header Configuration
 * Defines column structure for the Exports tab table
 * Similar to Uploads tab but for exported creations
 */

import { TableHeaderColumn } from "./uploadsTableHeader";

export const exportsTableHeader: TableHeaderColumn[] = [
  {
    visible: true,
    field: "clip",
    title: "Clip",
    sort: false,
    filter: false,
    type: "video",
    isUp: false,
    width: 138,
    value: false,
    restore: false,
    align: "left",
  },
  {
    visible: true,
    field: "name_description",
    title: "Clip Title",
    sort: true,
    filter: false,
    type: "string",
    isUp: false,
    width: 500,
    value: false,
    restore: false,
    align: "left",
  },
  {
    visible: true,
    field: "date_added",
    title: "Date Exported",
    sort: true,
    filter: false,
    type: "date",
    isUp: false,
    width: 185,
    value: false,
    restore: false,
    align: "left",
  },
  {
    visible: true,
    field: "duration",
    title: "Duration",
    sort: true,
    filter: false,
    type: "string",
    isUp: false,
    width: 110,
    value: false,
    restore: false,
    align: "left",
  },
  {
    visible: true,
    field: "processing_time",
    title: "Processing Time",
    sort: true,
    filter: false,
    type: "string",
    isUp: false,
    width: 150,
    value: false,
    restore: false,
    align: "left",
  },
  {
    visible: true,
    field: "file_type",
    title: "File Type",
    sort: true,
    filter: false,
    type: "string",
    isUp: false,
    width: 130,
    value: false,
    restore: false,
    align: "left",
    padding: "12px 12px",
  },
  {
    visible: true,
    field: "actions",
    title: "",
    sort: false,
    filter: false,
    type: "actions",
    isUp: false,
    width: "auto",
    value: false,
    restore: false,
    align: "right",
  },
];
